import React from 'react';
import {Route} from 'react-router-dom';

import {CancelPage} from './cancelPage';

/** Renders routes to cancel a meeting for use as children on a react-router Switch. */
export const cancelRoutes = <Route key="cancel" path="/cancel/:bookingToken" element={<CancelPage />} />;
